import {
  ItemReceiptLine,
  type ItemReceiptLineConstructor,
} from '../ItemReceiptLine'

export interface QuickBooksExportableItemReceiptConstructor {
  id: number // selection key for stage/archive/unstage
  purchaseOrderNumber: Nullable<number> // Procurify PO number of the received PO
  poUuid: string // detail link /receive/{po_uuid}
  date: ISODateString // "Date received" column + View Items modal date
  receiverName: string
  items: ItemReceiptLineConstructor[]
  stagedForExport: boolean // mapper defaults to false when absent (v3 row shape not live-observed on this tenant)
}

export class QuickBooksExportableItemReceipt {
  readonly id: number
  readonly purchaseOrderNumber: Nullable<number>
  readonly poUuid: string
  readonly date: Date
  readonly receiverName: string
  readonly items: ItemReceiptLine[]
  readonly stagedForExport: boolean

  constructor(data: QuickBooksExportableItemReceiptConstructor) {
    this.id = data.id
    this.purchaseOrderNumber = data.purchaseOrderNumber
    this.poUuid = data.poUuid
    this.date = new Date(data.date)
    this.receiverName = data.receiverName
    this.items = data.items.map((item) => new ItemReceiptLine(item))
    this.stagedForExport = data.stagedForExport
  }

  // "PO" column + View items lead: the row carries only the Procurify PO
  // number, labelled like an unexported PO on the purchase order tabs.
  get purchaseOrderLabel(): string {
    return this.purchaseOrderNumber !== null
      ? `PF${this.purchaseOrderNumber}`
      : ''
  }

  // "Number of lines" column (BHV-044).
  get lineCount(): number {
    return this.items.length
  }
}
